import {DeclarativeMutationConfig, graphql} from 'react-relay';
import {Disposable, Environment} from 'relay-runtime';
import {v4 as uuidv4} from 'uuid';
import Util from '../forecast-app/shared/util/util';
import {trackEvent} from '../tracking/amplitude/TrackingV2';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';
import {
	CreateExchangeRateInput,
	CreateExchangeRateMutation,
	CreateExchangeRateMutation$rawResponse,
} from './__generated__/CreateExchangeRateMutation.graphql';

// We pass the companyId in the input to be able to use it in the configs.
// Is there a better way to do this?
type CreateExchangeRateConfig = {
	companyId: string;
};

const mutation = graphql`
	mutation CreateExchangeRateMutation($input: CreateExchangeRateInput!) @raw_response_type {
		createExchangeRate(input: $input) {
			exchangeRate {
				node {
					id
					currency
					rate
					startDate
					isUsed
					createdAt
				}
			}
		}
	}
`;

function getConfigs(input: CreateExchangeRateConfig): DeclarativeMutationConfig[] {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.companyId,
			connectionInfo: [
				{
					key: 'Company_exchangeRates',
					rangeBehavior: 'append',
				},
			],
			edgeName: 'exchangeRate',
		},
	];
}

function getOptimisticResponse(input: CreateExchangeRateInput): CreateExchangeRateMutation$rawResponse {
	return {
		createExchangeRate: {
			exchangeRate: {
				node: {
					id: uuidv4(),
					currency: input.currency,
					rate: input.rate,
					startDate: null,
					isUsed: false,
					createdAt: new Date().toISOString(),
				},
			},
		},
	} as CreateExchangeRateMutation$rawResponse;
}

function commit(
	environment: Environment,
	input: CreateExchangeRateInput & CreateExchangeRateConfig,
	onSuccess?: (response: CreateExchangeRateMutation$rawResponse) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Exchange Rate', 'Created', input);
	return trackAndCommitMutation<CreateExchangeRateMutation>(environment, {
		mutation,
		variables: {
			input: {
				csrfToken: Util.getCsrfValue(),
				socketClientId: Util.getClientId(),
				currency: input.currency,
				rate: input.rate,
			},
		},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
